import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import {
  DashboardClientScope,
  DashboardMetrics,
  DashboardAccountsNeedingAttention,
  DashboardEnrollmentsAwaitingAcknowledgement,
  DashboardMembersOverTime,
  DashboardRecentAssignments,
  DashboardUpcomingOpenEnrollments
} from '../models/DashboardMetrics';

@Injectable({
  providedIn: 'root'
})
export class DashboardMetricsService extends BaseService {
  private readonly baseUrl = `${environment.LRNEXT_API_URL}/dashboard`;

  constructor(
    protected http: HttpClient,
    protected authService: AuthService
  ) {
    super(authService, http);
  }

  getMetrics(scope: DashboardClientScope): Observable<DashboardMetrics> {
    const params = new HttpParams().set('scope', scope);
    return this.get<DashboardMetrics>(`${this.baseUrl}/metrics`, { params });
  }

  getRecentAssignments(scope: DashboardClientScope): Observable<DashboardRecentAssignments> {
    const params = new HttpParams().set('scope', scope);
    return this.get<DashboardRecentAssignments>(`${this.baseUrl}/recent-assignments`, { params });
  }

  getUpcomingOpenEnrollments(scope: DashboardClientScope): Observable<DashboardUpcomingOpenEnrollments> {
    const params = new HttpParams().set('scope', scope);
    return this.get<DashboardUpcomingOpenEnrollments>(`${this.baseUrl}/upcoming-open-enrollments`, { params });
  }

  getAccountsNeedingAttention(scope: DashboardClientScope): Observable<DashboardAccountsNeedingAttention> {
    const params = new HttpParams().set('scope', scope);
    return this.get<DashboardAccountsNeedingAttention>(`${this.baseUrl}/accounts-needing-attention`, { params });
  }

  getEnrollmentsAwaitingAcknowledgement(
    scope: DashboardClientScope
  ): Observable<DashboardEnrollmentsAwaitingAcknowledgement> {
    const params = new HttpParams().set('scope', scope);
    return this.get<DashboardEnrollmentsAwaitingAcknowledgement>(
      `${this.baseUrl}/enrollments-awaiting-acknowledgement`,
      { params }
    );
  }

  getMembersOverTime(scope: DashboardClientScope): Observable<DashboardMembersOverTime> {
    const params = new HttpParams().set('scope', scope);
    return this.get<DashboardMembersOverTime>(`${this.baseUrl}/members-over-time`, { params });
  }
}
